import {Svg, SVG} from '@svgdotjs/svg.js';
import Vue from 'vue';

declare module 'vue/types/vue' {
  interface Vue {
    $svg: () => Svg;
  }
}

export default {
  install: (Vue: any) => {
    Vue.prototype.$svg = SVG;
  },
};
